import { api } from "..";

import { QueryProps } from "@/types/Api";
import { WinProbabilityAccuracyReport } from "@/types/ApiResponses/WinProbabilityAccuracy";

export interface GetWinProbabilityAccuracyParams {
  /** Look-back window in days (1 to 180; the backend defaults to 30). */
  days: number;
}

export const getWinProbabilityAccuracy = async (
  props: QueryProps<GetWinProbabilityAccuracyParams>
): Promise<WinProbabilityAccuracyReport> => {
  const res = await api.client.get(
    `/users-new/coupons/win-probability/accuracy`,
    {
      signal: props.signal,
      params: props.params,
    }
  );
  return res.data;
};
